export enum CommentEntityType {
	TEST = 'TEST',
	DEFECT = 'DEFECT',
	CASE_REVIEW = 'CASE_REVIEW',
}
